import { useEffect } from "react";

const SITE_URL = "https://giantfitnessclubs.com";
const DEFAULT_IMAGE = `${SITE_URL}/images/GiantFitness-more-equipment-no-waiting-LOGO.png`;

export function SEO({
  title,
  description,
  type = "website",
  image = DEFAULT_IMAGE,
  url,
  noindex = false,
  structuredData,
}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Giant Fitness` : "Giant Fitness - Unleash Your Giant Potential";
    const fullUrl = url ? `${SITE_URL}${url}` : SITE_URL;
    
    // Update title
    document.title = fullTitle;
    
    // Update or create meta tags
    const updateMetaTag = (property, content) => {
      let tag = document.querySelector(`meta[property="${property}"], meta[name="${property}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        if (property.startsWith("og:") || property.startsWith("twitter:")) {
          tag.setAttribute("property", property);
        } else {
          tag.setAttribute("name", property);
        }
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    
    // Basic meta tags
    if (description) {
      updateMetaTag("description", description);
    }
    
    // Open Graph tags
    updateMetaTag("og:type", type);
    updateMetaTag("og:title", fullTitle);
    if (description) {
      updateMetaTag("og:description", description);
    }
    updateMetaTag("og:image", image);
    updateMetaTag("og:url", fullUrl);
    updateMetaTag("og:site_name", "Giant Fitness");
    
    // Twitter Card tags
    updateMetaTag("twitter:card", "summary_large_image");
    updateMetaTag("twitter:title", fullTitle);
    if (description) {
      updateMetaTag("twitter:description", description);
    }
    updateMetaTag("twitter:image", image);
    
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", fullUrl);
    
    // Robots meta
    if (noindex) {
      updateMetaTag("robots", "noindex, nofollow");
    } else {
      updateMetaTag("robots", "index, follow");
    }
    
    // Structured data (JSON-LD)
    let script = document.querySelector('script[type="application/ld+json"]');
    if (structuredData) {
      if (!script) {
        script = document.createElement("script");
        script.setAttribute("type", "application/ld+json");
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(structuredData);
    } else if (script) {
      script.remove();
    }
  }, [title, description, type, image, url, noindex, structuredData]);
  
  return null;
}
